import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CDSMask } from '@app/utils/cds-mask';
import { Funcionario } from '@app/models/funcionario';
import { FuncionarioService } from '@app/services/funcionario.service';
// import { AutocompleteDataService } from '@app/services/autocomplete.service';
import { Permissao } from '@app/models/util/permissao';
import { UnidadeAcesso } from '@app/models/util/unidade-acesso';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ValidaDocumento } from '@app/utils/valida-documento';
import { ToastrService } from 'ngx-toastr';
import { ValidaSenha } from '@app/utils/valida-senha';
import { UsuarioTipoService } from '@app/services/usuario-tipo.service';

@Component({
  selector: 'app-funcionario-form',
  templateUrl: './funcionario-form.component.html',
})
export class FuncionarioFormComponent implements OnInit {

  titulo: string;
  novoUsuario: boolean = false;
  aguardandoSolicitacao:boolean=false;
  funcionario = new Funcionario();
  // usuarioTipoDataService: AutocompleteDataService;
  // unidadeDataService: AutocompleteDataService;
  cdsMask: CDSMask = new CDSMask();
  lstErros: string[];
  lstPermissoes: Permissao[];
  usuarioTipoDescricao: string;
  DataNascimento = '';

  lstUnidadeAcesso: UnidadeAcesso[];
  acessoAlterarSenhaOutroUsuario: boolean = false;

  lstUnidades: IdDescricao[] = [];
  lstCidade: IdDescricao[] = [];
  lstUsuarioTipo: IdDescricao[] = [];

  validaDocumento: ValidaDocumento = new ValidaDocumento();
  validadorSenha = ValidaSenha;

  editarSenha = false;
  novaSenha = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private usuarioTipoService: UsuarioTipoService,
    @Inject(ToastrService) public toastr: ToastrService,
    private funcionarioService: FuncionarioService,
    private consultasService: ConsultasService,
  ) {
    this.router.events.subscribe(() => window.scrollTo(0, 0));
  }

  ngOnInit() {

    this.consultasService.consultar('CIDADE').toPromise().then(data => this.lstCidade = data);
    this.consultasService.consultar('USUARIOTIPO').toPromise().then(data => this.lstUsuarioTipo = data);
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);

    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Funcionário' : 'Novo Funcionário';
      this.novoUsuario = id ? false : true;
      
      if (!id) {
        this.funcionario.PaisCelular = "Brasil";
        this.funcionario.Id = 0;
        this.funcionario.Ativo = true;
        this.funcionario.Funcionario = true;
      }

      this.obterPermissoes(id);
      this.obterUnidadesAcesso(id);

      if (this.funcionario.Id !== 0) {
        this.usuarioTipoService.verificaPermissaoUsuario().subscribe(
          (permissoes: any) =>{
            this.acessoAlterarSenhaOutroUsuario = permissoes.find(x => x.Descricao == 'AlterarSenhaOutroUsuario').Selecionado;
          })
        this.funcionarioService.obterPorId(id).subscribe(data => {
          this.funcionario = data;
          this.funcionario.RGDataExpedicao = data.RGDataExpedicao?.split('T')[0];
          this.DataNascimento = data.DataNascimento.split('T')[0];
          this.usuarioTipoDescricao = this.funcionario.UsuarioTipoDescricao;
        });
      }
    });
  }


  validaDados() {
    const mensagemErrosSenha = this.validadorSenha.obterRequisitosNaoAtendidos(this.funcionario.Senha?.trim());

    if (!this.validaDocumento.validaCPF_CNPJ(this.funcionario.CNPJ_CPF?.trim())) {
      this.toastr.error('Número de CPF/CNPJ Inválido');
      return false;
    }
    else if (!this.validaDocumento.validaTelefone(this.funcionario.Telefone?.trim())) {
      this.toastr.error('Número de Telefone Inválido');
      return false;
    }
    else if (!this.validaDocumento.validaCelular(this.funcionario.Celular?.trim())) {
      this.toastr.error('Número de Celular Inválido');
      return false;
    }
    else if (this.funcionario.Autenticacao2Fatores && !this.funcionario.Email?.trim()) {
      this.toastr.error('E-mail é obrigatório e deve ser válido para habilitar a Autenticação de Dois Fatores.');
      return false;
    }
    else if (!this.validaDocumento.validaEmail(this.funcionario.Email?.trim())) {
      this.toastr.error('E-mail Inválido');
      return false;
    }
    else if (mensagemErrosSenha && (this.novoUsuario || this.editarSenha)){
      this.toastr.error(mensagemErrosSenha, 'Validar Senha!');
      return false;
    }else{
      return true;
    }
  }

  onSubmit() {
    this.funcionario.DataNascimento = new Date(this.DataNascimento);
    this.funcionario.Permissoes = this.lstPermissoes;
    this.funcionario.UnidadesAcesso = this.lstUnidadeAcesso;
    this.funcionario.Senha = this.editarSenha ? this.novaSenha : this.funcionario.Senha;
    
    this.funcionario.Autenticacao2Fatores = this.funcionario.Autenticacao2Fatores ? true : false;
    if (!this.validaDados()) 
      return;
    
    this.aguardandoSolicitacao = true;
    this.funcionarioService.gravar(this.funcionario, this.editarSenha)
      .subscribe(
        () => { 
          this.toastr.success(`Cadastro ${(this.novoUsuario ? ' realizado' : ' alterado')} com sucesso!`)
          this.aguardandoSolicitacao = false;
          this.router.navigate(['./cadastros/funcionario']); 
        },
        (erro) => {
          this.lstErros = erro.error.errors;
          this.aguardandoSolicitacao = false;
        }
      );
    
  }

  // onItemSelect(selected: CompleterItem) {
  //   if (selected)
  //     this.funcionario.UsuarioTipoId = selected.originalObject.Id;
  // }

  obterPermissoes(id) {
    this.funcionarioService.obterTodasAsPermissoes(id)
      .subscribe(
        (data: any) => {
          this.lstPermissoes = data;
          this.lstPermissoes.forEach(permissao => this.atualizarAntigas(permissao));
        })
  }
  public atualizarAntigas(permissao) {
    permissao.SelecionadoAntigas = permissao.Selecionado;
  }
  public seleciona(permissao) {
    this.lstPermissoes.find(x => x.Descricao === permissao.Descricao).Selecionado = !permissao.Selecionado;
  }

  public selecionaUnidadeAcesso(unidade) {
    this.lstUnidadeAcesso.find(x => x.Descricao === unidade.Descricao).Selecionado = !unidade.Selecionado;
  }

  obterUnidadesAcesso(id) {
    this.funcionarioService.ObterTodasAsUnidadesPorUsuario(id)
      .subscribe(
        (data: any) => {
          this.lstUnidadeAcesso = data;
        });
  }

  editarSenhaCheckBox() {
    this.novaSenha = '';
  }

  // consultaCEP() {
  //   this.funcionarioService.consultarCEP(this.funcionario.Cep.split('-').join('')).subscribe(
  //     data => console.log(data)
  //   );

  // }
}
